import React from "react";

const Bills = () => {
  return <div className="p-10 bg-gray-100">Bills</div>;
};

export default Bills;
